import React from "react";
import { Header, Segment, Button, Icon, Form, Table, Checkbox, Modal, Image, TextArea, Dropdown, Input } from 'semantic-ui-react';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { Constants } from "../../../config/appConstants";
import AttachmentViewer from "../../sharedComponent/attachmentViewer/attachmentViewer.Container";
import NoResultFound from "../../sharedComponent/noResultFound";
import * as utils from '../../../services/utility/index';
import Loader from "../../sharedComponent/loader/loader";
import SelectTMVoucherModal from "../TMVoucher/TMVoucherComponents/SelectTMVoucherModal";
import { Fragment } from "react";
import PunchesModal from "../TimeCardCommons/PunchesModal";
import { RenderAttestation } from "../Attestation/RenderAttestation";
import { TimeCardWeekStatus } from "../TimeCardCommons/TimeCardStatus";

const SubmittedTimeCardComponent = props => {
    let count = 0;
    const timeRecordStatus = [Constants.PROCESSED_STATUS, Constants.NEW_STATUS].map(a => a.toLowerCase());

    return (
        <Segment.Group>
            <Fragment>
                <Segment className="stickyHeader">
                    <Header as="h3" size='medium' textAlign='center'> Submitted Timecard</Header>
                    <Header as="h2" size='tiny' className='layoutStyle d-flex align-items justify-content-between'>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                            <KeyboardDatePicker className="timeCardDate"
                                placeholder="MM/dd/yyyy"
                                value={props.timeCard.selectedDate}
                                onChange={date => props.handleDateChange(date)}
                                inputProps={{ readOnly: true }}
                                format="MM/dd/yyyy"
                                minDate={props.timeCard.weekStartDate}
                                maxDate={props.timeCard.weekEndingDate}
                                open={props.timeCard.isDatePickerOpen}
                                onClick={props.handleDatePickerOpenAndClose}
                                onClose={() => props.handleDatePickerOpenAndClose(true)}
                            />
                        </MuiPickersUtilsProvider>
                        <div className='d-flex align-items justify-content-between'>
                            <Button style={{ marginRight: '10px' }} primary className="borderRadius  whiteSpace" fluid size='small' onClick={props.onClickTimeCardReview}>
                                Timecard Review  </Button>
                            <Button style={{ opacity: props.timeCard.tmTaskCodeList.length > 0 ? 1 : 0.6, marginRight: '10px' }} secondary className="borderRadius borderColor whiteSpace" fluid size='small' onClick={() => props.timeCard.tmTaskCodeList.length > 0 && props.onClickTMVoucherBtn()}>
                                {Constants.TM_VOUCHER_BUTTON_TEXT} </Button>
                            <Button style={{ marginRight: '10px' }} secondary className="borderRadius borderColor whiteSpace" fluid size='small' onClick={props.getTimeCardIssue}>
                                Issues </Button>
                            <Button secondary className="borderRadius marginRight borderColor whiteSpace" fluid size='small' onClick={() => { props.onClickDailyDetails() }}>
                                Daily Details </Button>
                        </div>
                    </Header>
                </Segment>
                <Segment className="overflowScroll tableScrollData pb-5 ">
                    <Table unstackable className="submittedEmployee ">
                        <Table.Header className="tableHeaderScroll">
                            <Table.Row textAlign="center">
                                {/* <Table.HeaderCell rowSpan='2'></Table.HeaderCell> */}
                                <Table.HeaderCell rowSpan='2' className="whiteSpace">Punches</Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2'>Attestation</Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2'>Payroll Note </Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2'>Employee </Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2'>Project </Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2' className="whiteSpace">Task Code </Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2'>Shift </Table.HeaderCell>
                                <Table.HeaderCell className="hoursPadding" colSpan='3'>Hours</Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2'>Actuals </Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2'>Expectations </Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2'>Status </Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2'>Status Code </Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2' className="whiteSpace">Job Override </Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2' className="whiteSpace">Union Override </Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2' className="whiteSpace">Work done <br />at Job Site </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row textAlign="center">
                                {/* <Table.HeaderCell colSpan='7' ></Table.HeaderCell> */}
                                <Table.HeaderCell>ST</Table.HeaderCell>
                                <Table.HeaderCell>OT</Table.HeaderCell>
                                <Table.HeaderCell>DT</Table.HeaderCell>
                                {/* <Table.HeaderCell colSpan='7' ></Table.HeaderCell> */}
                            </Table.Row>
                        </Table.Header>

                        {props.timeCard.timeCardList && props.timeCard.timeCardList.length > 0 && props.timeCard.timeCardList.map((rowData, rowIndex) => {
                            let punches = "";
                            return (
                                <Table.Body key={rowIndex}>
                                    {
                                        rowData.timecardData.map((data, index) => {
                                            count++;
                                            const currentPunches = `${data.startTime} ${data.lunchStartTime} ${data.lunchEndTime} ${data.endTime} ${data.employeeName} (${data.employeeNumber})`;
                                            let samePunches = true;
                                            if (punches !== currentPunches) {
                                                punches = currentPunches;
                                                samePunches = false;
                                            }
                                            return (
                                                <Table.Row className={(count % 2 === 0) ? 'dateIndexEven' : 'dateIndexOdd'}>
                                                    {/* <Table.Cell></Table.Cell> */}
                                                    {samePunches ?
                                                        <Table.Cell></Table.Cell>
                                                        :
                                                        <Table.Cell>
                                                            <div className="startLunchTimeWraping" onClick={() => props.openOrClosePunchesModal({ isShowPunchesModal: true, selectedTimeCardPunches: data })}>
                                                                <span>{data.startTime}</span>
                                                                <span>{data.lunchStartTime}</span>
                                                                <span>{data.lunchEndTime}</span>
                                                                <span>{data.endTime}</span>
                                                            </div>
                                                        </Table.Cell>
                                                    }
                                                    <RenderAttestation isAllowAttestation={props.timeCard.isAllowAttestation} openAttestationModal={() => props.openAttestation(data.timeRecordID, data.intStatus)} attestationStatus={data.attestationStatus} timeCardStatus={data.intStatus} isFromTimeCard={false} />
                                                    <Table.Cell>
                                                        {index === 0 ?
                                                            data.payrollNote !== null ?
                                                                <div className="d-flex justify-content-center" >
                                                                    <div className="fileEditOutlineHighlighted" onClick={() => {
                                                                        props.openOrClosePayrollNoteModel(true, data);
                                                                    }}>
                                                                        <span className="iconify fSize-22" data-icon="mdi-file-edit-outline" data-inline="false" ></span>
                                                                    </div>
                                                                </div> :
                                                                <div className="d-flex justify-content-center">
                                                                    <div className="fileEditOutline" onClick={() => {
                                                                        props.openOrClosePayrollNoteModel(true, data);
                                                                    }}>
                                                                        <span className="iconify fSize-22" data-icon="mdi-file-edit-outline" data-inline="false" ></span>
                                                                    </div>
                                                                </div>
                                                            : ''}
                                                    </Table.Cell>
                                                    <Table.Cell className='whiteSpace text-left'><b>{index === 0 ? `${rowData.employeeName} (${data.employeeNumber})` : ''}</b></Table.Cell>
                                                    <Table.Cell>{data.projectNumber}</Table.Cell>
                                                    <Table.Cell>{data.taskNumber}</Table.Cell>
                                                    <Table.Cell>{data.shift}</Table.Cell>
                                                    <Table.Cell>{data.stHours ? data.stHours : 0}</Table.Cell>
                                                    <Table.Cell>{data.otHours ? data.otHours : 0}</Table.Cell>
                                                    <Table.Cell>{data.dtHours ? data.dtHours : 0}</Table.Cell>
                                                    <Table.Cell >
                                                        {
                                                            data.workNote !== null || data.workUnits !== null || data.isAttachmentAdded ?
                                                                <div className="d-flex justify-content-center" >
                                                                    <div className="fileEditOutlineHighlighted" onClick={() => {
                                                                        props.openOrCloseActualNoteModel(true, data);
                                                                    }}>
                                                                        <span className="iconify fSize-22" data-icon="mdi-file-edit-outline" data-inline="false" ></span>
                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className="d-flex justify-content-center" >
                                                                    <div className="fileEditOutline" onClick={() => {
                                                                        props.openOrCloseActualNoteModel(true, data);
                                                                    }}>
                                                                        <span className="iconify fSize-22" data-icon="mdi-file-edit-outline" data-inline="false" ></span>
                                                                    </div>
                                                                </div>
                                                        }
                                                    </Table.Cell>
                                                    <Table.Cell className={data.expectationNote !== null ? "highlightNotes text-center" : "text-center"}>
                                                        {
                                                            data.expectationNote !== null || data.expectationUnits > 0 ?
                                                                <div className="d-flex justify-content-center" >
                                                                    <div className="fileEditOutlineHighlighted" onClick={() => {
                                                                        props.openOrCloseExpectationNoteModel(true, data);
                                                                    }}>
                                                                        <span className="iconify fSize-22" data-icon="mdi-file-edit-outline" data-inline="false" ></span>
                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className="d-flex justify-content-center" >
                                                                    <div className="fileEditOutline" onClick={() => {
                                                                        props.openOrCloseExpectationNoteModel(true, data);
                                                                    }}>
                                                                        <span className="iconify fSize-22" data-icon="mdi-file-edit-outline" data-inline="false" ></span>
                                                                    </div>
                                                                </div>
                                                        }
                                                    </Table.Cell>
                                                    <Table.Cell className="text-center">
                                                        {TimeCardWeekStatus(data.intStatus)}
                                                    </Table.Cell>
                                                    <Table.Cell><div className="statusCdeLabel">
                                                        {data.fieldStatusDescription ? `${data.fieldStatusInitial}-${data.fieldStatusDescription}` : ""}
                                                    </div>
                                                    </Table.Cell>
                                                    <Table.Cell>{data.jobOverride}</Table.Cell>
                                                    <Table.Cell>{data.unionOverride}</Table.Cell>
                                                    <Table.Cell>{
                                                        <Checkbox
                                                            name="checkbox"
                                                            checked={(data.workDoneAtJobSite === 'true' || data.workDoneAtJobSite === 'Yes')}
                                                            disabled={true}
                                                        />}
                                                    </Table.Cell>

                                                </Table.Row>
                                            )
                                        })
                                    }
                                    <Table.Row className="totalHoursRows">
                                        <Table.Cell colSpan='6'></Table.Cell>
                                        <Table.Cell>Total</Table.Cell>
                                        <Table.Cell><b>{utils.getFormatedTotalHours(rowData.totalStHours)}</b></Table.Cell>
                                        <Table.Cell><b>{utils.getFormatedTotalHours(rowData.totalOtHours)}</b></Table.Cell>
                                        <Table.Cell><b>{utils.getFormatedTotalHours(rowData.totalDtHours)}</b></Table.Cell>
                                        <Table.Cell colSpan='7'></Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            )
                        })}
                    </Table>

                </Segment>

                <Segment>
                    <div className='d-flex justify-content-center align-items btnFooter'>
                        <Button secondary className="borderRadius w-10" size='small' onClick={props.onClickBack}>
                            Back  </Button>
                    </div>
                </Segment>


                {/* TimeCard Review Popup */}
                <Modal
                    open={props.timeCard.isOpenTimeCardReview}
                    closeOnDimmerClick={false}
                    size='tiny'
                    onClose={props.onCloseTimeCardReview}
                >
                    <Modal.Header className="text-center">Timecard Review</Modal.Header>
                    <Modal.Content className="text-center" scrolling style={{ minHeight: "auto" }}>
                        <Button primary className="borderRadius  whiteSpace w-65" size='small' onClick={props.onClickCurrentWeekTimeCard}>
                            View Current Week Timecard </Button>
                        <Button primary className="borderRadius  whiteSpace mt-2 w-65" size='small' onClick={props.onClickPreviousWeekTimeCard}>
                            View Previous Week Timecard</Button>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button secondary className="borderRadius w-25 mr-0" size='small' onClick={props.onCloseTimeCardReview}>
                            Back </Button>
                    </Modal.Actions>
                    {props.timeCard.isShowLoader &&
                        <Loader />
                    }
                </Modal>

                {/* Issue Note Popup */}
                <Modal
                    open={props.timeCard.isIssueNotesModalVisible}
                    closeOnDimmerClick={false}
                    size='tiny'
                    onClose={props.closeIssueNotes}
                >
                    <Modal.Header className="text-center">Issue Notes</Modal.Header>
                    <Modal.Content scrolling style={{ minHeight: "auto" }}>
                        <Form className="d-flex flexDirectionColumnReverse">
                            {(props.timeCard.issueNotesList && props.timeCard.issueNotesList.length > 0) ? props.timeCard.issueNotesList.map(issueNote => (
                                <div>
                                    <Form.Group inline>
                                        <label className="textTransformLower">Project</label>
                                        <Input className="w-100" fluid value={issueNote.projectNumber} disabled={true} />
                                    </Form.Group>
                                    <Form.Group inline>
                                        <label className='textAreaNoteLabel textTransformLower'>Notes</label>
                                        <TextArea className="minHeightTextArea" fluid selection rows='2' disabled={true} value={issueNote ? issueNote.issueNote : ""} />
                                    </Form.Group>
                                    <Form.Group inline style={{ position: 'relative', marginTop: '2rem', alignItems: 'stretch' }}>
                                        <label className='textTransformstatus'>Status Code</label>
                                        <TextArea className="disableTextArea" fluid value={issueNote.fieldStatusId ? `${issueNote.fieldStatusInitial}-${issueNote.fieldStatusDescription}` : ""} disabled={true} />
                                        <label className="textTransformLower_1">Lost Hours</label>
                                        <Input style={{ width: '25%', marginLeft: '1rem' }} fluid value={issueNote.lostHours} disabled={true} />
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Field>
                                            <label className="attachIssue">Attachments</label>
                                            <div className="attachmentImage">
                                                {issueNote.attachments && issueNote.attachments.map(attach => (
                                                    <img src={Constants.DATA_BASE64 + attach.attachmentContent} alt="" className='modalSubImage modalSubImage_margin' onClick={() => props.openAttachmentViewer(attach)} />
                                                ))}
                                            </div>
                                        </Form.Field>
                                    </Form.Group>
                                </div>
                            )) : <NoResultFound displayMessage={"No Issues Found"} />}
                        </Form>
                    </Modal.Content>
                    <Modal.Actions className="d-flex justify-content-center">
                        <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={props.closeIssueNotes}>
                            Back
                        </Button>
                    </Modal.Actions>
                    {props.timeCard.isShowLoader &&
                        <Loader />
                    }
                </Modal>

                {/* Start Time Lunch Time */}
                <PunchesModal
                    isShowPunchesModal={props.timeCard.isShowPunchesModal}
                    selectedTimeCardPunches={props.timeCard.selectedTimeCardPunches}
                    isShowLoader={props.timeCard.isShowLoader}
                    openOrClosePunchesModal={props.openOrClosePunchesModal}
                />

                <Modal
                    open={props.timeCard.isShowPayrollNoteModal}
                    closeOnDimmerClick={false}
                    size='tiny'
                >
                    <Modal.Header className="text-center">Payroll Note</Modal.Header>
                    <Modal.Content scrolling style={{ minHeight: "auto" }}>
                        <Form>
                            <Form.Group inline>
                                <TextArea className="minHeightTextArea maxHeightTextArea" placeholder="Notes" fluid selection value={props.timeCard.selectedTimeCard ? props.timeCard.selectedTimeCard.payrollNote : ''} disabled={true} />
                            </Form.Group>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions className="d-flex justify-content-center">
                        <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={() => props.openOrClosePayrollNoteModel(false)}>
                            Back
                        </Button>
                    </Modal.Actions>
                    {props.timeCard.isShowLoader &&
                        <Loader />
                    }
                </Modal>
                <Modal
                    open={props.timeCard.isShowExpectationNoteModal}
                    closeOnDimmerClick={false}
                    size='tiny'
                >
                    <Modal.Header className="text-center">Expectations</Modal.Header>
                    <Modal.Content className="overflowVisible" scrolling style={{ minHeight: "auto" }}>
                        <Form>
                            <Form.Group className='mb-2'>
                                <Form.Input disabled={true} className='modalInput unitInput' label='Units' placeholder='Units' width={6} value={props.timeCard.selectedTimeCard ? (props.timeCard.selectedTimeCard.expectationUnits !== 0 ? props.timeCard.selectedTimeCard.expectationUnits : '') : ''} />
                                <Form.Input disabled={true} className='modalInput' control={TextArea} rows="2" label='Notes' placeholder='Notes' width={10} value={props.timeCard.selectedTimeCard ? props.timeCard.selectedTimeCard.expectationNote : ''} />
                            </Form.Group>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions className="d-flex justify-content-center">
                        <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={() => props.openOrCloseExpectationNoteModel(false)}>
                            Back
                        </Button>
                    </Modal.Actions>
                    {props.timeCard.isShowLoader &&
                        <Loader />
                    }
                </Modal>
                <Modal
                    open={props.timeCard.isShowActualNoteModal}
                    closeOnDimmerClick={false}
                    size='tiny'
                >
                    <Modal.Header className="text-center">Actuals</Modal.Header>
                    <Modal.Content scrolling style={{ minHeight: "auto" }}>
                        <Form>
                            <Form.Group className='mb-2'>
                                <Form.Input disabled={true} className='modalInput unitInput actualField' label='Actual Units' placeholder='Actual Units' width={6} value={props.timeCard.selectedTimeCard ? (props.timeCard.selectedTimeCard.workUnits !== 0 ? props.timeCard.selectedTimeCard.workUnits : '') : ''} />
                                <Form.Input disabled={true} className='modalInput actualField' control={TextArea} rows="2" label='Actual Work Notes' placeholder='Actual Work Notes' width={10} value={props.timeCard.selectedTimeCard ? props.timeCard.selectedTimeCard.workNote : ''} />
                            </Form.Group>
                            <Form.Group widths='equal'>
                                <Form.Field>
                                    <label>Attachments</label>
                                    <div className='d-flex justify-content-between'>
                                        <div className="attachmentImage">
                                            {props.timeCard.selectedTimeCard && props.timeCard.selectedTimeCard.attachments && props.timeCard.selectedTimeCard.attachments.map((image, index) => (

                                                <div key={index} >
                                                    <img src={Constants.DATA_BASE64 + image.attachmentContent} className='modalSubImage modalSubImage_margin' alt="" onClick={() => props.openAttachmentViewer(image)} />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </Form.Field>
                            </Form.Group>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions className="d-flex justify-content-center">
                        <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={() => props.openOrCloseActualNoteModel(false)}>
                            Back
                        </Button>
                    </Modal.Actions>
                    {props.timeCard.isShowLoader &&
                        <Loader />
                    }
                </Modal>
            </Fragment>
            {/* Select Task Code Popup */}
            {props.timeCard.isShowTMVoucher &&
                <SelectTMVoucherModal
                    tmVoucherHeaderTwo={Constants.TM_VOUCHER_POPUP_HEADING_VIEW_DATA}
                    isShowTMVoucher={props.timeCard.isShowTMVoucher}
                    selectedTMVoucher={props.timeCard.selectedTMVoucher}
                    tmTaskCodeList={props.timeCard.tmTaskCodeList}
                    onChangeSelectTaskCode={props.onChangeSelectTaskCode}
                    onClickTMVoucherBackBtn={props.onClickTMVoucherBackBtn}
                    onClickSelectBtn={props.onClickSelectBtn}
                />
            }
            {
                props.timeCard.isAttachmentModelVisible &&
                <AttachmentViewer attachmentName={props.timeCard.selectedAttachment.attachmentName} attachmentContent={props.timeCard.selectedAttachment.attachmentContent} closeAttachmentViewer={props.closeAttachmentViewer} />
            }
            {props.timeCard.isShowLoader &&
                <Loader />
            }
        </Segment.Group>

    );
}

export default SubmittedTimeCardComponent;

SubmittedTimeCardComponent.displayName = "SubmittedTimeCardComponent";